// LocalStorage Keys
export const SEARCHRESULT_KEY = 'md_searches';
export const PROMO_APPS_SHOWN = 'promo_apps_shown';

// Connectors Constants
export const CONNECTOR_STATUS_ACTIVE = 'active';

// WS Message Types
export const WS_SEARCH_RESULT = 'search_result';
export const WS_SEARCH_COMPLETED = 'search_completed';
export const WS_LOG = 'log';
export const WS_ERROR = 'error';
export const WS_SUMMARIZE_RESPONSE = 'summarize_response';
export const WS_SUMMARIZE_STATUS = 'summary_status';
export const WS_SPACE_BOT_VERSION = 'space_bot_version';

// Default lang
export const DEFAULT_LANG = 'en';

// App version (placeholder replaced in CI/CD). Keep type widened to string to avoid literal comparison warnings.
export const APP_VERSION: string = '5.13.0';

// Returns the effective app version or a fallback.
export function resolveAppVersion(fallback: string = '0.0.0'): string {
  return APP_VERSION.startsWith('#{') ? fallback : APP_VERSION;
}

export const FREE_COMPANY_NAME = '__medullar_free__';

export const TRIAL_COMPANY_NAME = '__medullar_trial__';

export const DEFAULT_COMPANY_NAME = '__medullar_base__';

export const DEV_COMPANY_NAME = '__medullar_dev__';

export const restrictedCompanyNames = [FREE_COMPANY_NAME, TRIAL_COMPANY_NAME, DEFAULT_COMPANY_NAME, DEV_COMPANY_NAME];

// External Links
export const allConnectorsLink = 'https://www.medullar.com/us/en/connectors';

// Medullar extension
export const MEDULLAR_EXTENSION_LINK_CHROME =
  'https://chromewebstore.google.com/detail/medullar/pepnajnbokenohoebldbohpemkaddgfp';

export const MEDULLAR_EXTENSION_LINK_EDGE =
  'https://microsoftedge.microsoft.com/addons/detail/medullar/ligkllebcnghmpkholemaacfaeknkado';

// Bot agents
export const MEDULLAR_AGENT_ICON = 'assets/images/openai.png';

export const BOT_AGENTS = [
  {
    name: 'medullar_single_agent',
    id: 'single_agent',
    deepAnalysis: true,
    description: 'medullar_single_agent_description',
    reasoningEffort: true,
    icon: MEDULLAR_AGENT_ICON,
  },
  {
    name: 'medullar_single_agent_xai',
    id: 'single_agent_xai',
    deepAnalysis: true,
    description: 'medullar_single_agent_xai_description',
    reasoningEffort: false,
    icon: 'assets/images/grok.png',
  },
  {
    name: 'medullar_single_agent_claude',
    id: 'single_agent_claude',
    deepAnalysis: true,
    description: 'medullar_single_agent_claude_description',
    reasoningEffort: false,
    icon: 'assets/images/claude.png',
  },
  {
    name: 'medullar_research_agent',
    id: 'research_agent',
    deepAnalysis: true,
    description: 'medullar_research_agent_description',
    reasoningEffort: false,
    icon: MEDULLAR_AGENT_ICON,
  },
  {
    name: 'medullar_fact_check_agent',
    id: 'fact_check_agent',
    deepAnalysis: false,
    description: 'medullar_fact_check_agent_description',
    reasoningEffort: false,
    icon: MEDULLAR_AGENT_ICON,
  },
  {
    name: 'search_agent',
    id: 'search_agent',
    deepAnalysis: false,
    description: 'search_agent_description',
    reasoningEffort: false,
    icon: MEDULLAR_AGENT_ICON,
  },
];

// Highlight colors
export const HIGHLIGHT_COLORS = ['#fdfeaa', '#b6fbff', '#93fe79', '#fdc6f8', '#ddbdff'];

// Where to start tips
export const WHERE_TO_START_TIPS = [
  'where_to_start_tip_1',
  'where_to_start_tip_2',
  'where_to_start_tip_3',
  'where_to_start_tip_4',
  'where_to_start_tip_5',
  'where_to_start_tip_6',
  'where_to_start_tip_7',
  'where_to_start_tip_8',
];
// Device width breakpoints
export const DEVICE_MOBILE_MAX_WIDTH = 768;
export const DEVICE_TABLET_MAX_WIDTH = 1024;
export const DEVICE_DESKTOP_MIN_WIDTH = 1025;
